<template>
  <div class="confirm">
    <header class="p-f18 p-fw" style="margin-bottom: 10px">信息確認</header>
    <div class="container" style="margin-bottom: 40px">
      <div class="box-1" v-if="type === 'entity'">
        <label for="username" class="label">收卡人</label>
        <div>{{ params.apply_name }}{{ getSex }}</div>
      </div>
      <div class="box-1">
        <label for="username" class="label">手機號碼</label>
        <div>+{{ params.apply_mob_country }}-{{ params.apply_mob_no }}</div>
      </div>
      <div class="box-1">
        <label for="username" class="label">郵箱</label>
        <div>{{ params.apply_email }}</div>
      </div>
      <div class="box-1" v-if="type === 'entity'">
        <label for="username" class="label">收件地址</label>
        <div>{{ params.recv_address }}</div>
      </div>
      <div class="flex" style="margin-bottom: 20px" v-if="type === 'entity'">
        <label for="username" class="label">購卡用途</label>
        <div class="flexc">
          <span>{{ params.card_usage }}</span>
          <span class="p-999"
            >(我們依照您的購卡用途，免費贈送貼心迷妳卡片，祝您購卡愉快。)</span
          >
        </div>
      </div>
      <div class="flex" style="margin-bottom: 20px" v-if="type === 'virtual'">
        <label for="username" class="label">購卡用途</label>
        <div class="flex" style="width: 60%">{{ params.card_usage }}</div>
      </div>
      <div class="box-1">
        <label for="isMasterCard" class="label">類型</label>
        <div class="checked">
          <div class="inside"></div>
        </div>
        <!-- <div class="unchecked" v-else @click="isMasterCard = true"></div> -->
        <div class="flexaj master-logo">
          <img v-if="params.card_organ === '00'" src="@/assets/master_logo.jpg" alt />
          <img v-else src="@/assets/unp.png" alt width="50" height="30" />
        </div>
      </div>
    </div>
    <header class="p-f18 p-fw" style="margin-bottom: 10px">費用合計</header>
    <div class="container" style="margin-bottom: 20px">
      <div class="box-1">
        <label for="username" class="label">卡充值面額</label>
        <div class="flexa">
          <span class="p-fw">{{ getTotalAmount }}</span>
          <span style="margin-left: 4px">{{ params.card_currency }}</span>
          <div class="p-999" style="margin-left: 5px">
            (
            <span v-for="(item, index) of params.card_list" :key="index">
              {{ item.amount + "*" + item.count }}
              <span v-if="index !== params.card_list.length - 1">+</span> </span
            >)
          </div>
        </div>
      </div>
      <div class="box-1">
        <label for="username" class="label">卡費</label>
        <div>
          <span class="p-fw">{{ getCard_total_price }}</span>
          <span style="margin-left: 4px">{{ params.card_currency }}</span>
          <span class="p-999" style="margin-left: 5px"
            >( {{ getFee }}x{{ params.card_num }} {{ getText }} )</span
          >
        </div>
      </div>
      <div class="box-1" v-if="type === 'entity'">
        <label for="username" class="label">行政費</label>
        <div>
          <span class="p-fw">{{ getAdminPrice }}</span>
          <span style="margin-left: 4px">{{ params.card_currency }}</span>
        </div>
      </div>
      <div class="box-1">
        <label for="username" class="label">合計</label>
        <div>
          <span class="p-fw p-FA800A p-f18">{{ getTotal }}</span>
          <span style="margin-left: 4px">{{ params.card_currency }}</span>
        </div>
      </div>
      <div class="tips flexaj">
        溫馨提示：禮品卡為不可再充值產品，一經支付，不設更換.
      </div>
    </div>
    <div class="button-group flexaj" v-if="isButtonGroupShow">
      <el-button @click="back">返回修改</el-button>
      <el-button type="primary" @click="confirm">確認並支付</el-button>
    </div>
    <!-- <div class="container flexaj" style="border:none;">
      <span class="tips">請點擊接收到的郵件鏈接執行支付</span>
    </div>-->
  </div>
</template>

<script>
import { aPost2 } from "@/utils/request";
import api from "@/utils/api";
export default {
  data() {
    return {
      isButtonGroupShow: true,
      isLoading: false,
      isMasterCard: false,
      type: "",
      params: {},
      priceGroup: {
        card_total_price: 0,
        card_total_amount: 0,
        card_admin_price: 0,
        total: 0,
      },
    };
  },
  methods: {
    async getPrice() {
      let params = JSON.parse(sessionStorage.getItem("params"));
      let res = await aPost2(api.applyPrice, params);
      if (res) {
        if (res.data.errCode === "99999") {
          this.priceGroup = res.data.retData;
        } else {
          this.$message.error({ message: `${res.data.errMsg}` });
          this.isLoading = false;
          this.back();
        }
      }
    },
    back() {
      if (this.type === "entity") {
        this.$router.push({ name: "entity", params: this.params });
      } else {
        this.$router.push({ name: "virtual", params: this.params });
      }
    },
    async confirm() {
      this.isLoading = true;
      let params = JSON.parse(sessionStorage.getItem("params"));
      let res = await aPost2(api.order, params);
      if (res) {
        if (res.data.errCode === "99999") {
          sessionStorage.setItem(
            "mobile",
            `+${this.params.apply_mob_country}-${this.params.apply_mob_no}`
          );
          this.$message.success(`提交成功！`);
          this.$router.push({
            path: "/banklist",
            query: { order_no: res.data.retData.order_no },
          });
          // window.location.href = res.data.retData.pay_url;
          this.isButtonGroupShow = false;
          this.isLoading = false;
        } else {
          this.$message.error({ message: `${res.data.errMsg}` });
          this.isLoading = false;
        }
      }
    },
  },
  mounted() {
    if (Object.keys(this.$route.params).length == 0) {
      const cardType = JSON.parse(sessionStorage.getItem("params")).card_type
      this.$router.replace({ name: cardType === "00" ? "entity" : "virtual" });
    } else {
      this.params = this.$route.params.params;
      this.type = this.$route.params.type;
      this.getPrice();
    }
  },
  computed: {
    getText() {
      return this.type === "entity" &&
        Number(this.priceGroup.discount_number) > 0
        ? "首次訂購獲豁免一張卡費"
        : "";
    },
    getCard_total_price() {
      return (this.priceGroup.card_total_price / 100).toFixed(2);
    },
    getTotalAmount() {
      return (this.priceGroup.card_total_amount / 100).toFixed(2);
    },
    getAdminPrice() {
      return (this.priceGroup.card_admin_price / 100).toFixed(2);
    },
    getTotal() {
      return (this.priceGroup.total / 100).toFixed(2);
    },
    getSex() {
      return this.params.apply_sex === "1" ? "先生" : "女士";
    },
    getFee() {
      if (this.type === "entity") {
        return this.params.card_currency === "HKD"
          ? "25"
          : this.params.card_currency === "USD"
          ? "3.2"
          : "25";
      } else {
        return this.params.card_currency === "HKD"
          ? "20"
          : this.params.card_currency === "USD"
          ? "2.5"
          : "20";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm {
  width: 960px;
  margin: 40px auto 60px;
  font-size: 14px;
  .container {
    border: 1px solid #ccc;
    border-radius: 2px;
    padding: 20px 70px;
    /* padding: 40px; */
  }
  .box-1 {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }
  .label {
    display: inline-flex;
    justify-content: flex-end;
    width: 200px;
    margin-right: 20px;
  }
  .checked {
    border: 1px solid #409eff;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    .inside {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #409eff;
    }
  }
  .unchecked {
    width: 16px;
    height: 16px;
    border: 1px solid #ccc;
    border-radius: 50%;
  }
  .master-logo {
    margin-left: 10px;
    padding: 4px 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  .tips {
    color: #999;
    /* color: #379aff;
    cursor: pointer; */
  }
}
</style>